/**
 * @copyright Copyright 2021 Epic Systems Corporation
 * @file collaboration menu icon
 * @author Will Cooper
 * @module Epic.VideoApp.Icons.Collaborative
 */

import React, { FC, memo } from "react";
import { IconProps } from ".";

/**
 * The Collaborative component
 * @param props The props ;)
 */
const Collaborative: FC<IconProps> = memo((props) => {
	const { title } = props;
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
			{title && <title>{title}</title>}
			<rect x="5.79" y="6.6" width="12.95" height="18.86" rx="0.94" />
			<rect x="20.78" y="6.6" width="5.46" height="5.46" rx="0.96" />
			<rect x="20.78" y="13.3" width="5.46" height="5.46" rx="0.96" />
			<rect x="20.78" y="20" width="5.46" height="5.46" rx="0.96" />
		</svg>
	);
});

Collaborative.displayName = "Collaborative";

export default Collaborative;
